import $ from 'jquery'

class WTPhotoController {
    constructor() {
        this._cache = []

        this._timer = []

        this._recentTimes = []

        this._totalFinishedLoads = 0

        this.imgCounter = -1

        this.container = window

        this.onlySizeChange = false
        this.includeHeight = false

        this.imageCacheFunc = null
        this.imageCache = []
        this.imageCacheSize = 5

        this.testSampleSize = 2

        this.imageSizes = []

        this.QUALITY_HI = 2
        this.QUALITY_LO = 0
        this.QUALITY_MEDIUM = 1
        this.QUALITY_UPGRADE = 3
        this.QUALITY_DOWNGRADE = 4

        this.currentPrefix = ''
        this.currentQuality = this.QUALITY_MEDIUM
        this.currentSize = null

        this.debug = false

        this.suffix = ''

        this.firstVisitAfterQualityChange = 0 //Total images served for the current quality/size combindation
        this.lastQualityChange = 0 //Was the last change an upgrade or downgrade?
        this.blockUpgradesCounter = 0 // Upgrades are blocked if the counter has a value greater than zero

        /**
         * Initialize the Photo Controller
         *
         * @param  {Array} sizes:			The allowed sizes that the controller will work with
         * @param  {int} testSampleSize:	Number of photos to use for testing if the new size is appropriate
         * give connection speed
         * @param  {int} imageCacheSize:	Number of photos that the Walking Tour use in the cache
         * @param  {Func} imageCacheFunc:	A reference to the caching function in the walking tour. The
         * controller might call the function.
         * @param  {String} container:		The id for the DOM element that contains the walking tour
         * @param  {Bool} includeHeight:	When calculating what image size to use include the height into
         * the calculation
         * @param  {Bool} onlySizeChange:	Don't use connection speed to determine which image size to
         * server. Only use screen resolution
         * @param {Bool} resetcache: Set to true, the browser wont use image from the cache
         */
        this.init = function(
            sizes,
            testSampleSize,
            imageCacheSize,
            imageCacheFunc,
            container,
            includeHeight,
            onlySizeChange,
            resetcache
        ) {
            if ((sizes && sizes.length == 0) || !sizes) return

            var i = 0,
                prev = null,
                level

            this.onlySizeChange = onlySizeChange
            this.imageCacheFunc = imageCacheFunc
            this.testSampleSize = testSampleSize
            this.imageCacheSize = imageCacheSize
            this.includeHeight = includeHeight
            this.container = container

            //For the image to be refreshed by appending a random string
            this.suffix = resetcache ? '?t=' + Math.random() : ''

            if (testSampleSize >= imageCacheSize) {
                alert('Test Sample Size must be larger than Cache size for WTPhotoController')
            }

            sizes.sort(function(a, b) {
                return a.size - b.size
            })

            this.imageSizes.push({
                size: 0,
                prefix: sizes[0].size,
                hi: sizes[0].hi,
            })
            for (i; i < sizes.length; i++) {
                if (i !== 0) {
                    level = prev.size
                    this.imageSizes.push({
                        size: level,
                        prefix: sizes[i].size,
                        hi: sizes[i].hi,
                    })
                }
                prev = sizes[i]
            }
            this._calculatePhotoPrefix()
        }

        this.getPhoto = function(path) {
            return path
                .replace(/(\/media\/\d+\/tour\/\d+)\/(\w+)/, '$1/' + this.currentPrefix + '_$2.jpg') //walking tour
                .replace(/(\/media\/\d+\/photos\/\d+)/, '$1/' + this.currentPrefix + '.jpg') //media tour
        }

        this._imageLoaded = function(event) {
            var endTime = new Date().getTime(),
                time = endTime - this._timer[event.data._imgCounter],
                quality = 0,
                prefix,
                totalTime = 0,
                avgTime = 0,
                i = 0

            // stored in browser cache so don't use
            if (time < 30) {
                return this
            }

            this._recentTimes[this._totalFinishedLoads % this.testSampleSize] = time

            for (i; i < this._recentTimes.length; i++) {
                totalTime += this._recentTimes[i]
            }
            avgTime = totalTime / this._recentTimes.length
            if (this.debug) console.log(this._recentTimes)

            if (this._recentTimes.length == this.testSampleSize || avgTime > 3000) {
                if (this._calculatePhotoPrefix(avgTime) !== 0) {
                    this._updateImageCache()
                }
            } else {
                if (this.debug) console.log('Sample size is still small')
            }

            this._totalFinishedLoads++

            return this
        }

        this._calculatePhotoPrefix = function(avgTime) {
            var i = this.imageSizes.length - 1,
                size,
                time,
                lowerSize,
                containerWidth,
                containerHeight,
                allowUpgrades = --this.blockUpgradesCounter <= 0,
                // This value should be derived instead of hardcoded. For now we will use
                // the most common ratio of DSLRs.
                photoAspectRatio = 3 / 2,
                change = 0,
                dimensionLimit,
                dimConvertor = 1

            if (this.container === window) {
                containerWidth = $(window).width()
                containerHeight = $(window).height()
            } else {
                containerWidth = $('#' + this.container).width()
                containerHeight = $('#' + this.container).height()
            }

            // Is the photo resizing driven by the width or the height limit.
            if (this.includeHeight && containerWidth / containerHeight < photoAspectRatio) {
                // Resizing is driven by Height
                dimensionLimit = containerHeight
                dimConvertor = 1 / photoAspectRatio
            } else {
                dimensionLimit = containerWidth
            }

            --this.blockUpgradesCounter

            for (i; i >= 0; i--) {
                if (dimensionLimit >= this.imageSizes[i].size * dimConvertor) {
                    size = this.imageSizes[i]
                    if (i > 0) {
                        lowerSize = this.imageSizes[i - 1]
                    } else {
                        lowerSize = this.imageSizes[i]
                    }
                    break
                }
            }

            if (this.currentSize !== null && this.currentSize.size != size.size) {
                change = this._setQuality(size, this.QUALITY_MEDIUM)
                avgTime = undefined
            } else if (avgTime === undefined || this.onlySizeChange) {
                change = this._setQuality(size, this.QUALITY_MEDIUM)
            } else if (this.currentQuality == this.QUALITY_LO) {
                if (avgTime < 1300 && allowUpgrades) {
                    change = this._setQuality(size, this.QUALITY_MEDIUM)
                }
            } else if (this.currentQuality == this.QUALITY_MEDIUM) {
                if (avgTime > 2200) {
                    change = this._setQuality(lowerSize, this.QUALITY_LO)
                } else if (avgTime < 1300 && allowUpgrades && size.hi !== '') {
                    change = this._setQuality(size, this.QUALITY_HI)
                }
            } else if (this.currentQuality == this.QUALITY_HI) {
                if (avgTime > 1800) {
                    change = this._setQuality(size, this.QUALITY_MEDIUM)
                } else if (avgTime > 2500) {
                    change = this._setQuality(lowerSize, this.QUALITY_LO)
                }
            }

            if (change !== 0 && avgTime !== undefined && !this.onlySizeChange) {
                if (change == this.QUALITY_DOWNGRADE) {
                    // The last quality upgrade was too much for the connection because we are downgrading
                    // within the first 3 (test sample size) images back to previous quality. So block the next 15 requests
                    // for quality change
                    if (this.firstVisitAfterQualityChange && this.lastQualityChange == this.QUALITY_UPGRADE) {
                        if (this.debug) console.log('Blocking upgrades')
                        this.waitCounter = 15
                    }
                }
                // reset total images for quality
                this.lastQualityChange = change
                this._recentTimes = []
                this._totalFinishedLoads = -1
                this.firstVisitAfterQualityChange = true
            } else {
                this.firstVisitAfterQualityChange = false
            }

            if (this.debug)
                console.log('AvgTime: ' + avgTime + ' Size: ' + size.size + ' prefix: ' + this.currentPrefix)
            return change
        }

        this._setQuality = function(size, quality) {
            var change
            this.currentPrefix = size.prefix + (quality == this.QUALITY_HI && size.hi != undefined ? '_' + size.hi : '')
            change = quality > this.currentQuality ? this.QUALITY_UPGRADE : this.QUALITY_DOWNGRADE
            this.currentQuality = quality
            this.currentSize = size
            return change
        }

        this._removeFromImageCache = function(photo) {
            var i = 0,
                list = []
            for (i; i < this.imageCache.length; i++) {
                if (photo !== this.imageCache[i]) {
                    list.push(this.imageCache[i])
                }
            }
            this.imageCache = list
        }

        this._addToImageCache = function(photo) {
            // If buffer reached limit then remove first item in the list
            if (this.imageCache.length > this.imageCacheSize) {
                this.imageCache = this.imageCache.splice(1, this.imageCache - 1)
            }
            this.imageCache.push(photo)
        }

        this._updateImageCache = function() {
            if (this.imageCacheFunc == null) return

            if (this.debug) console.log('Updating Cached Images')
            var i = 0,
                img = null
            for (i; i < this.imageCache.length; i++) {
                img = this.getPhoto(this.imageCache[i])
                if ($.inArray(img, this._cache) == -1) {
                    //this.imageCacheFunc(this.imageCache[i]);
                }
            }
        }

        this.loadPhoto = function(imgid, path, isCache, onLoadData, onload) {
            var photo = this.getPhoto(path),
                inLocalCache = $.inArray(photo, this._cache) != -1,
                scope = this,
                tempImage = false

            // Create an image object if it does not exist in the DOM
            if (imgid == null || imgid == undefined || imgid == '') {
                imgid = 'cacheImg' + Math.round(Math.random() * 10000)
                $('body').prepend(
                    "<img style='display:none' class='cached_images' id='" +
                        imgid +
                        "' alt='cached image for performance' aria-hidden='true' >"
                )
                tempImage = true
            }

            // remove all event handlers for load
            $('#' + imgid).off('load.secondary')

            if (!inLocalCache && !this.onlySizeChange) {
                $('#' + imgid).on('load.primary', null, { _imgCounter: ++this.imgCounter }, function(event) {
                    scope._imageLoaded(event)
                    $(this).off('load.primary')

                    // Remove the temporary image object
                    if (tempImage) {
                        $(this).remove()
                    }
                })
                // JS is single threaded. No worry about thread conflict here
                this._cache.push(photo)
                this._timer[this.imgCounter] = new Date().getTime()
            }
            if (onload !== undefined) {
                if (onLoadData === undefined || onLoadData === null) {
                    onLoadData = {}
                }
                onLoadData.photo = photo
                $('#' + imgid).on('load.secondary', null, onLoadData, onload)
            }

            $('#' + imgid).attr('src', photo + scope.suffix)

            if ($('#' + imgid)[0].complete && onload) {
                $('#' + imgid).off('load.secondary')
                onload({ data: onLoadData })
            }

            if (!this.onlySizeChange) {
                // Update the cache photos buffer
                if (isCache) {
                    if (!inLocalCache) {
                        this._addToImageCache(path)
                    }
                } else {
                    this._removeFromImageCache(path)
                }
            }
        }
    }
}
export default new WTPhotoController()
